import React from 'react';

/**
 * JumpToLatestPill — Slack-style affordance shown at the bottom-right of the
 * message list when the user has scrolled up and new messages have arrived.
 * Click scrolls the list to the latest message.
 *
 * Owned by `MessageList.new.js`. KAP-312.
 */
function JumpToLatestPill({ count, onClick }) {
  const safeCount = Math.max(0, Math.floor(Number(count) || 0));
  const a11yLabel =
    safeCount === 0
      ? 'Jump to latest message'
      : `Jump to latest. ${safeCount} new message${safeCount === 1 ? '' : 's'} below.`;
  return (
    <button
      type="button"
      className="msg-jump-to-latest-pill"
      onClick={onClick}
      aria-label={a11yLabel}
      data-testid="jump-to-latest-pill"
    >
      <span className="msg-jump-to-latest-pill-text">
        {safeCount > 0 ? <strong>{safeCount} new</strong> : null}
        <span>Jump to latest</span>
      </span>
      <svg
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 16 16"
        width="14"
        height="14"
        className="msg-jump-to-latest-pill-icon"
      >
        <path
          d="M3 6l5 5 5-5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export default JumpToLatestPill;
